import { useEffect, useState } from 'react'

const BUILD_VERSION = import.meta.env.VITE_GIT_SHA || 'dev'

export function VersionBadge() {
  const [newVersion, setNewVersion] = useState(false)

  useEffect(() => {
    if (BUILD_VERSION === 'dev' || BUILD_VERSION === 'unknown') return

    // Check version on API responses via a periodic poll
    const checkVersion = async () => {
      try {
        const res = await fetch('/api/version')
        if (!res.ok) return
        const data = await res.json()
        const serverVersion = data.version
        if (serverVersion && serverVersion !== 'dev' && serverVersion !== 'unknown' && serverVersion !== BUILD_VERSION) {
          setNewVersion(true)
        }
      } catch {
        // Ignore fetch errors
      }
    }

    // Check immediately, then every 5 minutes
    checkVersion()
    const interval = setInterval(checkVersion, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  if (!newVersion) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-3 text-sm">
      <span>A new version is available.</span>
      <button
        onClick={() => window.location.reload()}
        className="bg-white text-blue-600 px-3 py-1 rounded font-medium hover:bg-blue-50 transition-colors"
      >
        Reload
      </button>
    </div>
  )
}
